<div class="modal-warning">
  <div class="modal-warning__title">
    <h2>{{ 'MODAL_WARNING_DIALOG.TITLE' | i18nextEager }}</h2>
    <span class="modal-warning__title__close" (click)="closeDialog()">
      <img src="/assets/icons/close_modal.svg" alt="" />
    </span>
  </div>
  <div class="modal-warning__text">{{ 'MODAL_WARNING_DIALOG.TEXT' | i18nextEager }}</div>
  <img class="modal-warning__img" src="/assets/images/road.svg" alt="" />
  <div class="modal-warning__buttons">
    <button class="secondary" (click)="notSave()">{{ 'COMMONS.DONT_SAVE' | i18nextEager }}</button>
    <button (click)="save()">{{ 'COMMONS.SAVE' | i18nextEager }}</button>
  </div>
</div>
